export function prettifySegment(segment: string): string {
  return segment
    .replace(/[-_]/g, ' ') // replace hyphens/underscores
    .replace(/([A-Z])/g, ' $1') // split camelCase
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function capitalize(value: string): string {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function prettifyDimensionPath(path: string): string {
  if (!path) return '';

  const parts = path.split(':').map(prettifySegment);

  if (parts.length === 1) return parts[0];

  // First segment becomes "X:"
  const [first, ...rest] = parts;

  return `${first}: ${rest.join(' | ')}`;
}

export function decodeParams<T extends Record<string, string>>(params: T): T {
  const decoded = {} as T;
  for (const [key, value] of Object.entries(params)) {
    if (value == null) {
      decoded[key as keyof T] = value as T[keyof T];
      continue;
    }
    try {
      decoded[key as keyof T] = decodeURIComponent(value) as T[keyof T];
    } catch {
      decoded[key as keyof T] = value as T[keyof T];
    }
  }
  return decoded;
}
